import { Action } from 'infra/types'
import { LabelNode } from 'state/tags/labels.tree.helper'
import {
  IDrawers,
  IInvoiceTag,
  IKeyVals,
  ITagsState,
  IlinkDelinkInvoiceTagPayload
} from './tags.types'

export const TagsActions = {
  FETCH_TAGS: 'tags/fetchTags',
  FETCH_TAGS_SUCCESS: 'tags/fetchTagsSuccess',
  SET_CUSTOMER_TO_GROUP_RATE_KEY_MAPPER: 'tags/SET_CUSTOMER_TO_GROUP_RATE_KEY_MAPPER',

  CREATE_TAG: 'tags/createTag',
  CREATE_TAG_SUCCESS: 'tags/createTagSuccess',
  CREATE_TAG_FAILURE: 'tags/createTagFailure',

  UPDATE_TAG: 'tags/updateTag',
  UPDATE_TAG_SUCCESS: 'tags/updateTagSuccess',
  UPDATE_TAG_FAILURE: 'tags/updateTagFailure',

  FETCH_ACCOUNT_TAGS: 'tags/fetchAccountTags',
  FETCH_ACCOUNT_TAGS_SUCCESS: 'tags/fetchAccountTagsSuccess',

  LINK_DELINK_ACCOUNT_TAGS: 'tags/linkDelinkAccountTags',
  LINK_DELINK_ACCOUNT_TAGS_SUCCESS: 'tags/linkDelinkAccountTagsSuccess',
  LINK_DELINK_ACCOUNT_TAGS_FAILURE: 'tags/linkDelinkAccountTagsFailure',

  FETCH_INVOICE_TAGS: 'tags/fetchInvoiceTags',
  FETCH_INVOICE_TAGS_SUCCESS: 'tags/fetchInvoiceTagsSuccess',

  LINK_DELINK_INVOICE_TAGS: 'tags/linkDelinkInvoiceTags',
  LINK_DELINK_INVOICE_TAGS_SUCCESS: 'tags/linkDelinkInvoiceTagsSuccess',

  TOGGLE_EDIT_TAG_DIALOG: 'tags/toggleEditTagDialog',
  HANDLE_DRAWER_TOGGLE: 'tags/HANDLE_DRAWER_TOGGLE',

  // Key Label Changes
  FETCH_GLOBAL_KEYS_LABEL_VALUES: 'tags/FETCH_GLOBAL_KEYS_LABEL_VALUES',
  FETCH_GLOBAL_KEYS_LABEL_VALUES_SUCCESS: 'tags/FETCH_GLOBAL_KEYS_LABEL_VALUES_SUCCESS',
  SET_LABELS_TREE: 'tags/setlabelsTree',
  SET_LABELS_FILTER: 'tags/SET_LABELS_FILTER',
  SET_FILTER_BY_LABEL_DRAWER: 'tags/SET_FILTER_BY_LABEL_DRAWER',
  SET_LOADER: 'tags/SET_LOADER',
  RESET_PRESELECTED_LABEL_FILTERS: 'tags/RESET_PRESELECTED_LABEL_FILTERS'
}

export const setLabelFilters = (
  payload:
    | {
        key_id: string
        val_ids: string[]
      }[]
    | undefined
): Action<
  | {
      key_id: string
      val_ids: string[]
    }[]
  | undefined
> => ({
  type: TagsActions.SET_LABELS_FILTER,
  payload
})

export const getTags = (): Action<null> => ({
  type: TagsActions.FETCH_TAGS,
  payload: null
})

export const resetPreselectedLabelFilter = (): Action<null> => ({
  type: TagsActions.RESET_PRESELECTED_LABEL_FILTERS,
  payload: null
})

export const setLabelFilterLoaders = (payload: {
  loaderName: keyof ITagsState['loaders']
  status: boolean
}): Action<{
  loaderName: keyof ITagsState['loaders']
  status: boolean
}> => ({
  type: TagsActions.SET_LOADER,
  payload: payload
})

export const setLabelsTree = (
  payload: { key_id: string; key_name: string; children: LabelNode }[]
): Action<{ key_id: string; key_name: string; children: LabelNode }[]> => ({
  type: TagsActions.SET_LABELS_TREE,
  payload
})

export const setCustomerToGroupRateKeyMapper = (
  payload: {
    entity_id: string
    val_ids: string[]
  }[]
): Action<
  {
    entity_id: string
    val_ids: string[]
  }[]
> => ({
  type: TagsActions.SET_CUSTOMER_TO_GROUP_RATE_KEY_MAPPER,
  payload
})

export const getTagsSuccess = (payload: any): Action<any> => ({
  type: TagsActions.FETCH_TAGS_SUCCESS,
  payload
})

export const createTag = (payload: any): Action<any> => ({
  type: TagsActions.CREATE_TAG,
  payload
})

export const createTagSuccess = (payload: any): Action<any> => ({
  type: TagsActions.CREATE_TAG_SUCCESS,
  payload
})

export const createTagFailure = (): Action<null> => ({
  type: TagsActions.CREATE_TAG_FAILURE,
  payload: null
})

export const updateTag = (payload: any): Action<any> => ({
  type: TagsActions.UPDATE_TAG,
  payload
})

export const updateTagSuccess = (payload: any): Action<any> => ({
  type: TagsActions.UPDATE_TAG_SUCCESS,
  payload
})

export const updateTagFailure = (): Action<null> => ({
  type: TagsActions.UPDATE_TAG_FAILURE,
  payload: null
})

export const getAccountTags = (): Action<null> => ({
  type: TagsActions.FETCH_ACCOUNT_TAGS,
  payload: null
})

export const getAccountTagsSuccess = (payload: any): Action<any> => ({
  type: TagsActions.FETCH_ACCOUNT_TAGS_SUCCESS,
  payload
})

export const linkDelinkAccountTags = (payload: any): Action<any> => ({
  type: TagsActions.LINK_DELINK_ACCOUNT_TAGS,
  payload
})

export const linkDelinkAccountTagsSuccess = (): Action<null> => ({
  type: TagsActions.LINK_DELINK_ACCOUNT_TAGS_SUCCESS,
  payload: null
})

export const linkDelinkAccountTagsFailure = (): Action<null> => ({
  type: TagsActions.LINK_DELINK_ACCOUNT_TAGS_FAILURE,
  payload: null
})

export const toggleEditTagDialog = (payload: boolean): Action<boolean> => ({
  type: TagsActions.TOGGLE_EDIT_TAG_DIALOG,
  payload
})

export const getInvoiceTags = (payload: {
  transactionId: string
  accountId: string
}): Action<{ transactionId: string; accountId: string }> => ({
  type: TagsActions.FETCH_INVOICE_TAGS,
  payload
})

export const getInvoiceTagsSuccess = (payload: IInvoiceTag[]): Action<IInvoiceTag[]> => ({
  type: TagsActions.FETCH_INVOICE_TAGS_SUCCESS,
  payload
})

export const linkDelinkInvoiceTags = (
  payload: IlinkDelinkInvoiceTagPayload
): Action<IlinkDelinkInvoiceTagPayload> => ({
  type: TagsActions.LINK_DELINK_INVOICE_TAGS,
  payload
})

export const linkDelinkInvoiceTagsSuccess = (payload: IInvoiceTag[]): Action<IInvoiceTag[]> => ({
  type: TagsActions.LINK_DELINK_INVOICE_TAGS_SUCCESS,
  payload
})

export const handleDrawerToggle = (payload: IDrawers): Action<IDrawers> => ({
  type: TagsActions.HANDLE_DRAWER_TOGGLE,
  payload
})

export const setFilterByLabelDrawer = (payload: {
  drawerName: 'labelFilterDrawer'
  drawerStatus: boolean
  successCallBack?: (_: any) => void
  preSelectedLabelFilters?: {
    key_id: string
    val_ids: string[]
  }[]
}): Action<{
  drawerName: 'labelFilterDrawer'
  drawerStatus: boolean
  successCallBack?: (_: any) => void
  preSelectedLabelFilters?: {
    key_id: string
    val_ids: string[]
  }[]
}> => ({
  type: TagsActions.SET_FILTER_BY_LABEL_DRAWER,
  payload
})

export const getBusinessLabelsKeyVals = (): Action<null> => ({
  type: TagsActions.FETCH_GLOBAL_KEYS_LABEL_VALUES,
  payload: null
})

export const getBusinessLabelsKeyValSuccess = (payload: IKeyVals[]): Action<IKeyVals[]> => ({
  type: TagsActions.FETCH_GLOBAL_KEYS_LABEL_VALUES_SUCCESS,
  payload
})
